<template>
  <div
    class="pa-2"
    :style="{ height: 'calc(100dvh - 64px)' }"
  >
    <iframe
      src="/privacy.pdf"
      width="100%"
      height="100%"
    ></iframe>
  </div>
</template>
